export function formatFileSizeMb(sizeInBytes: number): string {
  if (sizeInBytes <= 0) {
    return '0 mb';
  }

  const mb = sizeInBytes / (1024 * 1024);
  return `${mb.toFixed(1).replace('.0', '')} mb`;
}
